const VIDEOS_EXT = [
  "mp4",
  "avi",
  "mkv",
  "wmv",
  "mov",
  "flv",
  "webm",
  "3gp",
  "mpeg",
  "mpg",
  "m4v",
  "ts",
  "ogv",
  "rm",
  "rmvb",
  "mts",
  "m2ts",
  "vob",
  "qt",
];
const PDF_EXT = ["pdf"];
const DOC_EXT = ["doc", "docx"];
const IMG_EXT = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "tiff",
  "webp",
  "svg",
  "ico",
];
const PPT_EXT = ["ppt", "pptx", "pot", "potx", "pps", "ppsx"];
const EXCEL_EXT = ["xls", "xlsx", "xlsm", "xlsb", "xlt", "xltx", "xltm", "csv"];

const getFileTypeFromExt = (ext) => {
  if (VIDEOS_EXT.includes(ext)) {
    return "video";
  } else if (PDF_EXT.includes(ext)) {
    return "pdf";
  } else if (DOC_EXT.includes(ext)) {
    return "word";
  } else if (IMG_EXT.includes(ext)) {
    return "image";
  } else if (PPT_EXT.includes(ext)) {
    return "ppt";
  } else if (EXCEL_EXT.includes(ext)) {
    return "excel";
  }
};

const isPreviewable = (ext) => {
  if (
    VIDEOS_EXT.includes(ext) ||
    PDF_EXT.includes(ext) ||
    IMG_EXT.includes(ext)
  ) {
    return true;
  } else if (
    DOC_EXT.includes(ext) ||
    PPT_EXT.includes(ext) ||
    EXCEL_EXT.includes(ext)
  ) {
    return false;
  }
};

module.exports = {
  getFileTypeFromExt,
  isPreviewable,
};
